var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_36002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0002C27.929 40.0002 34.7803 35.3857 38.0153 28.6958H1.98438C5.21938 35.3857 12.0706 40.0002 19.9998 40.0002Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9564C23.8419 26.9564 26.9564 23.8419 26.9564 19.9999C26.9564 16.158 23.8419 13.0435 19.9999 13.0435C16.158 13.0435 13.0435 16.158 13.0435 19.9999C13.0435 23.8419 16.158 26.9564 19.9999 26.9564Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 24.3477C22.4014 24.3477 24.348 22.4011 24.348 19.9999C24.348 17.5987 22.4014 15.6521 20.0002 15.6521C17.5989 15.6521 15.6523 17.5987 15.6523 19.9999C15.6523 22.4011 17.5989 24.3477 20.0002 24.3477Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 14.6348L21.3412 17.6768L24.6462 17.3173L22.6824 19.9999L24.6462 22.6825L21.3412 22.323L19.9998 25.3651L18.6585 22.323L15.3535 22.6824L17.3173 19.9999L15.3535 17.3173L18.6585 17.6768L19.9998 14.6348Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_36002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.8ba2804e16258e609dda088151683a80.svg";
export { ForwardRef as ReactComponent };